"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BiLoggerClientFactory = exports.EventCategories = exports.createBatchQueue = exports.manager = exports.setHost = exports.factory = void 0;
var wix_bi_logger_client_1 = require("@wix/wix-bi-logger-client");
var tracker = __importStar(require("./lib/tracker"));
var logger = __importStar(require("./logger"));
var factory = function (options) {
    if (options === void 0) { options = {}; }
    var trackSession = options.trackSession || typeof options.trackSession === 'undefined';
    if (trackSession) {
        tracker.track(logger.factory, { force: trackSession === 'force' });
    }
    return logger.factory(options);
};
exports.factory = factory;
exports.setHost = logger.setHost;
exports.manager = wix_bi_logger_client_1.manager;
exports.createBatchQueue = wix_bi_logger_client_1.createBatchQueue;
exports.EventCategories = logger.EventCategories;
exports.BiLoggerClientFactory = logger.BiLoggerClientFactory;
exports.default = {
    factory: exports.factory,
    setHost: logger.setHost,
    manager: wix_bi_logger_client_1.manager,
    createBatchQueue: wix_bi_logger_client_1.createBatchQueue,
    EventCategories: logger.EventCategories,
    BiLoggerClientFactory: logger.BiLoggerClientFactory,
};
//# sourceMappingURL=tracking-logger.js.map